/* TRKVLT Morph Equalizer Player — Shopify Edition */
(function () {
  var PLAY_SECONDS = 18;
  var N_BARS = 32;

  function barHeights(seed) {
    var a = [];
    var x = seed * 131 + 7;
    for (var i = 0; i < N_BARS; i++) {
      x = (x * 9301 + 49297) % 233280;
      a.push(0.22 + (x / 233280) * 0.78);
    }
    return a;
  }

  function ease(t) {
    t = t < 0 ? 0 : t > 1 ? 1 : t;
    return t * t * (3 - 2 * t);
  }

  function buildBars(container, heights, color) {
    container.innerHTML = '';
    for (var i = 0; i < heights.length; i++) {
      var span = document.createElement('span');
      var h = Math.round(7 + heights[i] * 24);
      span.style.cssText = 'flex:1 1 0;min-width:2px;height:' + h + 'px;border-radius:2px;background:' + color + ';display:inline-block;';
      container.appendChild(span);
    }
  }

  var players = {};
  var rafId = 0;

  function initPlayers() {
    var els = document.querySelectorAll('[data-morph-player]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var id = el.dataset.morphPlayer;
      if (players[id]) continue;

      var seed = parseInt(el.dataset.seed || '7', 10);
      var heights = barHeights(seed);

      var grayContainer = el.querySelector('.bp-bars-gray');
      var magContainer = el.querySelector('.bp-bars-magenta');
      if (grayContainer) buildBars(grayContainer, heights, '#3A3A3A');
      if (magContainer) buildBars(magContainer, heights, '#F90D65');

      players[id] = {
        el: el,
        seed: seed,
        heights: heights,
        open: false,
        playing: false,
        openAt: 0,
        closeAt: 0,
        playBase: 0,
        playStart: 0
      };

      (function (pid) {
        players[pid].el.addEventListener('click', function (e) {
          e.stopPropagation();
          togglePlayer(pid);
        });
      })(id);
    }
  }

  function anyAnimating() {
    var now = performance.now();
    var ids = Object.keys(players);
    for (var i = 0; i < ids.length; i++) {
      var p = players[ids[i]];
      if (p.playing) return true;
      if ((now - p.openAt) < 460) return true;
      if ((now - p.closeAt) < 460) return true;
    }
    return false;
  }

  function kickRAF() {
    if (rafId) return;
    function loop() {
      renderAll();
      if (anyAnimating()) {
        rafId = requestAnimationFrame(loop);
      } else {
        rafId = 0;
      }
    }
    rafId = requestAnimationFrame(loop);
  }

  function togglePlayer(id) {
    var now = performance.now();
    var p = players[id];
    var ids = Object.keys(players);
    for (var i = 0; i < ids.length; i++) {
      var oid = ids[i];
      if (oid !== id && players[oid].open) {
        players[oid].closeAt = now;
        players[oid].open = false;
        players[oid].playing = false;
      }
    }
    if (p.open) {
      if (p.playing) {
        p.playBase += now - p.playStart;
        p.playing = false;
      } else {
        p.playStart = now;
        p.playing = true;
      }
    } else {
      p.closeAt = now;
      p.openAt = now;
      p.open = true;
      p.playing = true;
      p.playBase = 0;
      p.playStart = now;
    }
    kickRAF();
  }

  function renderAll() {
    var now = performance.now();
    var ids = Object.keys(players);
    for (var i = 0; i < ids.length; i++) {
      renderPlayer(players[ids[i]], now);
    }
  }

  function renderPlayer(p, now) {
    var el = p.el;
    var f;
    if (p.open) {
      f = ease((now - p.openAt) / 420);
    } else {
      f = 1 - ease((now - p.closeAt) / 420);
    }
    f = f < 0 ? 0 : f > 1 ? 1 : f;

    var elapsed = p.playBase + (p.playing ? (now - p.playStart) : 0);
    var prog = p.open ? ((elapsed / 1000) % PLAY_SECONDS) / PLAY_SECONDS : 0;
    var sweepRight = (100 * (1 - prog)).toFixed(1);
    var eqOpacity = (f * 1.6 < 1 ? f * 1.6 : 1).toFixed(2);

    el.style.width = 'calc(68px + (100% - 68px) * ' + f.toFixed(3) + ')';

    var iconEl = el.querySelector('.bp-play-icon');
    if (iconEl) {
      if (p.playing) {
        iconEl.innerHTML = '<span style="display:flex;gap:4px;"><span style="width:5px;height:20px;background:#fff;border-radius:1px;display:inline-block;"></span><span style="width:5px;height:20px;background:#fff;border-radius:1px;display:inline-block;"></span></span>';
      } else {
        iconEl.innerHTML = '<span style="width:0;height:0;border-style:solid;border-width:10px 0 10px 16px;border-color:transparent transparent transparent #fff;margin-left:4px;display:inline-block;"></span>';
      }
    }

    var eqEl = el.querySelector('.bp-eq');
    if (eqEl) {
      eqEl.style.opacity = eqOpacity;
      var sweepLayer = eqEl.querySelector('.bp-sweep');
      if (sweepLayer) {
        sweepLayer.style.clipPath = 'inset(0 ' + sweepRight + '% 0 0)';
      }
    }
  }

  document.addEventListener('mousedown', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-morph-player]')) return;
    var now = performance.now();
    var ids = Object.keys(players);
    var changed = false;
    for (var i = 0; i < ids.length; i++) {
      var p = players[ids[i]];
      if (p.open) {
        p.closeAt = now;
        p.open = false;
        p.playing = false;
        changed = true;
      }
    }
    if (changed) kickRAF();
  }, true);

  setInterval(function () {
    var now = performance.now();
    var ids = Object.keys(players);
    for (var i = 0; i < ids.length; i++) {
      var p = players[ids[i]];
      if (!p.playing || !p.open) continue;
      var elapsed = (p.playBase + (now - p.playStart)) / 1000;
      if (elapsed >= PLAY_SECONDS) {
        p.playBase = 0;
        p.playStart = now;
      }
    }
  }, 500);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlayers);
  } else {
    initPlayers();
  }

  window.trkvltInitPlayers = initPlayers;
})();
